import { render, staticRenderFns } from "./newsdetails.vue?vue&type=template&id=b12b89c8&scoped=true"
import script from "./newsdetails.vue?vue&type=script&lang=js"
export * from "./newsdetails.vue?vue&type=script&lang=js"
import style0 from "./newsdetails.vue?vue&type=style&index=0&id=b12b89c8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12b89c8",
  null
  
)

export default component.exports